import { ISelectOption } from '~/src/dash/components/dropdowns/common';

export type TierID = -1 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

export const TierIDToLabelMap: Record<TierID, string> = {
  [-1]: 'None',
  11: 'Tier 0',
  10: 'Tier 1',
  9: 'Tier 2',
  8: 'Tier 3',
  7: 'Tier 4',
  6: 'Tier 5',
  5: 'Tier 6',
  4: 'Tier 7',
  3: 'Tier 8',
  2: 'Tier 9',
  1: 'Tier 10',
};

export const TierOptions: ISelectOption[] = [
  { id: -1, label: 'None', tKey: 'None' },
  { id: 11, label: 'Tier 0', tKey: 'TierNumber', tProps: { number: 0 } },
  { id: 10, label: 'Tier 1', tKey: 'TierNumber', tProps: { number: 1 } },
  { id: 9, label: 'Tier 2', tKey: 'TierNumber', tProps: { number: 2 } },
  { id: 8, label: 'Tier 3', tKey: 'TierNumber', tProps: { number: 3 } },
  { id: 7, label: 'Tier 4', tKey: 'TierNumber', tProps: { number: 4 } },
  { id: 6, label: 'Tier 5', tKey: 'TierNumber', tProps: { number: 5 } },
  { id: 5, label: 'Tier 6', tKey: 'TierNumber', tProps: { number: 6 } },
  { id: 4, label: 'Tier 7', tKey: 'TierNumber', tProps: { number: 7 } },
  { id: 3, label: 'Tier 8', tKey: 'TierNumber', tProps: { number: 8 } },
  { id: 2, label: 'Tier 9', tKey: 'TierNumber', tProps: { number: 9 } },
  { id: 1, label: 'Tier 10', tKey: 'TierNumber', tProps: { number: 10 } },
];
